/**
 * ============================================================================
 * MASTER SERVICE: Operator Service (`tbl_operators` - Sheet 8)
 * ============================================================================
 * Purpose:
 *   Handles API requests for telecom gateway operators (Meta, Karix, Pinnacle, etc.).
 *
 * Database Scope:
 *   Master Database (`digimaster`)
 * ============================================================================
 */

import { createCrudService } from "../../core/services/crudServiceFactory";

const operatorService = createCrudService("operators");

export default operatorService;
